import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-registration-status',
  imports: [SharedModule],
  templateUrl: './registration-status.component.html',
  styleUrl: './registration-status.component.scss'
})
export class RegistrationStatusComponent {

  @Input() currentStatus: string = 'Raw';

  statuses = ['Pending', 'Under Review', 'Accepted', 'Rejected'];

  getStatusClass(status: string): string {
    const currentIndex = this.statuses.indexOf(this.currentStatus);
    const statusIndex = this.statuses.indexOf(status);

    if (statusIndex < currentIndex) {
      return 'completed'; // Previous steps (dark)
    } else if (statusIndex === currentIndex) {
      return 'current'; // Current step (yellow)
    } else {
      return 'upcoming'; // Upcoming steps (light)
    }
  }
}
